import { defineStore } from 'pinia';
import { computed, type ComputedRef } from 'vue';
import { useCartCheckoutStore } from '@white-label-store/cart-checkout';
import { isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled } from '@white-label-plugin/launch-darkly';
import type {
  CartItem,
} from '@white-label-types/parking-checkout';

export const usePriorityPassLoungeStore = defineStore('priorityPassLounge', () => {

  const priorityPassLoungeItem: ComputedRef<CartItem | undefined> = computed(() => {
    const cartCheckoutStore = useCartCheckoutStore();
    const checkoutCartItems = cartCheckoutStore.readCartItems;
    return checkoutCartItems.find((cartItem) => {
      const isCheckoutFieldAdditionalTravellerNamesEnabled = !Array.isArray(cartItem.inventory_item.additional_fields) && cartItem.inventory_item.additional_fields['additional_passengers'] ? cartItem.inventory_item.additional_fields['additional_passengers'].is_show === true : false;
      return isCheckoutFieldAdditionalTravellerNamesEnabled;
    });
  });

  const hasPriorityPassLoungeItem = computed(() => {
    return Boolean(isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && priorityPassLoungeItem.value);
  });
  const hasAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && priorityPassLoungeItem.value ? priorityPassLoungeItem.value.quantity > 1 : false;
  });

  const displayPriorityPassLoungeAdditionalTravellers = computed(() => {
    return isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled() && hasAdditionalTravellers.value;
  });

  const isPriorityPassLoungeAdditionalTravellersDetailsRequired = computed(() => {
    if (!priorityPassLoungeItem.value) return false;
    return priorityPassLoungeItem.value.inventory_item.additional_fields
    && priorityPassLoungeItem.value.inventory_item.additional_fields['additional_passengers']
    && priorityPassLoungeItem.value.inventory_item.additional_fields['additional_passengers'].is_required === true;
  });

  return {
    priorityPassLoungeItem,
    hasPriorityPassLoungeItem,
    hasAdditionalTravellers,
    displayPriorityPassLoungeAdditionalTravellers,
    isPriorityPassLoungeAdditionalTravellersDetailsRequired,
  };
}, {
  persist: true,
});
